import { readonlyStringListQuery } from "components/scrapEyeDataDashboard/navigation/queryCodecs";
import { readonlyIdentifierListQuery } from "components/scrapEyeDataDashboard/navigation/queryCodecs";
import { choiceQuery } from "components/scrapEyeDataDashboard/navigation/queryCodecs";
import { useNavigationQuery } from "components/scrapEyeDataDashboard/navigation/NavigationQueryProvider";
import { Stack } from "@mui/material";

import {
  VideoSourceSelector,
  useVideoSources,
} from "./components/VideoSourceSelector";
import { MultiFeedVideoPlayer } from "./components/MultiFeedVideoPlayer";
import { EnsureGcsTokenExists } from "components/scrapEyeVideoPlayer/GcsTokenProvider";
import { VideoControlProvider } from "components/scrapEyeDataDashboard/VideoPlayer/contexts/VideoControlContext";
import { HotkeyProvider } from "components/scrapEyeDataDashboard/VideoPlayer/contexts/HotkeyContext";
import { PLAYBACK_SCOPE } from "components/scrapEyeDataDashboard/VideoPlayer/constants";

type Props = Readonly<{
  deviceId: number;
}>;

export const LiveStreamPanel = ({ deviceId }: Props) => {
  const [sourceMode, setSourceMode] = useNavigationQuery(
    "liveVideoSource",
    "angle",
    choiceQuery(["angle", "camera", "angle_group"] as const),
    "replace"
  );
  const [selectedAngleIds, setSelectedAngleIds] = useNavigationQuery(
    "liveVideoAngles",
    [],
    readonlyIdentifierListQuery,
    "replace"
  );
  const [selectedCameraPhysicalIds, setSelectedCameraPhysicalIds] =
    useNavigationQuery(
      "liveVideoCameras",
      [],
      readonlyStringListQuery,
      "replace"
    );

  const videoSource = useVideoSources({
    deviceId,
    mode: sourceMode,
    selectedAngleIds,
    selectedCameraPhysicalIds,
  });

  return (
    <EnsureGcsTokenExists>
      <HotkeyProvider>
        <VideoControlProvider>
          <Stack p={2} spacing={2}>
            <VideoSourceSelector
              deviceId={deviceId}
              mode={sourceMode}
              onModeChange={setSourceMode}
              selectedAngleIds={selectedAngleIds}
              onAngleIdsChange={setSelectedAngleIds}
              selectedCameraPhysicalIds={selectedCameraPhysicalIds}
              onCameraPhysicalIdsChange={setSelectedCameraPhysicalIds}
            />
            <MultiFeedVideoPlayer
              hotkeyScope={PLAYBACK_SCOPE}
              source={videoSource}
              startIso=""
              endIso=""
              isLive
            />
          </Stack>
        </VideoControlProvider>
      </HotkeyProvider>
    </EnsureGcsTokenExists>
  );
};
